import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogCategory, LoggerService, LogPage, LogType } from 'src/app/core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';

@Component({
    selector: 'select-seat-modal',
    templateUrl: './select-seat-modal.component.html',
    styleUrls: ['./select-seat-modal.component.scss'],
    standalone: false
})
export class SelectSeatModalComponent {
    @Input() section: any;
    public seat: number;

    constructor(
        private logger: LoggerService,
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);

    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.CourseCatalog, category);
    }

    public ngOnInit(): void {}
}
